<!--
* @Author: 窦云飞 df1987131@yeah.net
* @Date: 2023-11-29 17:33:57
* @LastEditors: 窦云飞 df1987131@yeah.net
* @LastEditTime: 2023-12-06 18:20:08
* @FilePath: /epec-purchase-shopping-mall/Users/douyunfei/Documents/epec-mall/components/enquiry/tipDialog.vue
* @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <eDialog
      dialog-title="提示"
      dialog-type="other"
      button-tip="前往"
      :show-btn="showBtn"
      :center-dialog-visible="tipVisible"
      :append-to-body="appendToBody"
      :popup-width="'500px'"
      @updateVisible="resetPopupData"
      @resetPopupData="resetPopupData"
      @submitPopupData="submitPopupData"
    >
      <div>{{ message }}</div>
    </eDialog>
  </div>
</template>

<script>
import { epecMallUrl } from '@/modules/projectA/api/config';
import eDialog from '../common/e-dialog';

export default {
  name: 'TipDialog',
  components: {
    eDialog,
  },
  props: {
    tipVisible: Boolean,
    isTreeTip: Boolean,
    isPrice: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showBtn: true,
      appendToBody: true,
      /* message:
this.isPrice === '报价'
? '当前企业暂未开通易专采，平台限定“开通易专采+配置组织架构”的企业才能参与报价，是否前往申请开通易专采。'
: this.isPrice === '询价'
? '当前企业暂未开通易专采，平台限定“开通易专采+配置组织架构”的企业才能发布询价，是否前往申请开通易专采。'
: '', */
    };
  },
  computed: {
    message() {
      if (this.isPrice === '报价') {
        if (this.isTreeTip) {
          return '当前企业暂未配置组织架构，平台限定“开通易专采+配置组织架构”的企业才能参与报价，是否前往配置组织架构。';
        }
        return '当前企业暂未开通易专采，平台限定“开通易专采+配置组织架构”的企业才能参与报价，是否前往申请开通易专采。';
      }
      if (this.isPrice === '询价') {
        if (this.isTreeTip) {
          return '当前企业暂未配置组织架构，平台限定“开通易专采+配置组织架构”的企业才能发布询价，是否前往配置组织架构。';
        }
        return '当前企业暂未开通易专采，平台限定“开通易专采+配置组织架构”的企业才能发布询价，是否前往申请开通易专采。';
      }
      return '';
    },
  },
  methods: {
    resetPopupData() {
      this.$emit('closeEnquiryDialog');
    },
    submitPopupData() {
      if (this.isTreeTip) {
        this.$router.push({ path: '/institutionManage' });
      } else {
        window.open(`${epecMallUrl}/purchaseZone`, '_blank');
      }
      this.$emit('closeEnquiryDialog');
    },
  },
};
</script>

<style scoped lang="scss"></style>
